
import {
  getProductionPage,
  updStorageProduction,
  invalidProduction,
  delProduction,
  updStartProductionProduction
} from "@/api/api-basic";
import { optionKey, getOptionList } from "@/api/api-dict";
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import qualityCheck from "./components/quality-check.vue";
import adjustPriorities from "./components/adjust-priorities.vue";
import devDeliverGoods from "./components/dev-deliver-goods.vue";
import addProduction from "./components/add-production.vue";
import i18n from "@/config/i18n";
@Component({
  components: {
    qualityCheck,
    adjustPriorities,
    devDeliverGoods,
    addProduction
  }
})
export default class PiProductionOrder extends Vue {
  private time: object[] = [];
  private total = 0;
  private formInline: objAny = {
    startTime: "",
    endTime: "",
    modelName: "",
    productionStatus: "",
    globalPageIndex: 1,
    globalPageSize: 10,
    numOrProject: ""
  };
  private loading = false;

  private productionStatusList: object[] = [];
  private selectList: object[] = [];
  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      type: "selection",
      width: 60,
      align: "center"
    },
    {
      title: i18n.t("productionOrder.index"),
      type: "index",
      width: 70
    },
    {
      title: i18n.t("productionOrder.priority"),
      key: "priority",
      width: 70
    },
    {
      title: i18n.t("productionOrder.orderType"),
      key: "orderTypeDesc",
      minWidth: 100
    },
    {
      title: i18n.t("productionOrder.contractBillNumber"),
      key: "contractBillNumber",
      minWidth: 130
    },
    {
      title: i18n.t("productionOrder.projectName"),
      key: "projectName",
      slot: "projectName",
      minWidth: 120
    },
    {
      title: i18n.t("productionOrder.platformModel"),
      key: "platformModel",
      slot: "platformModel",
      minWidth: 120
    },
    {
      title: i18n.t("productionOrder.pileNum"),
      key: "pileNum",
      slot: "pileNum",
      minWidth: 100
    },
    {
      title: i18n.t("productionOrder.doneModelNum"),
      key: "doneModelNum",
      minWidth: 100
    },
    {
      title: i18n.t("productionOrder.productionStatus"),
      key: "productionStatusDesc",
      minWidth: 100
    },
    {
      title: i18n.t("productionOrder.createTime"),
      key: "createTime",
      slot: "createTime",
      minWidth: 140
    },
    {
      title: i18n.t("operation"),
      slot: "action",
      minWidth: 160
    }
  ];
  public getTotalPileNum(list: object[]) {
    let total = 0;
    list.map((item: objAny) => {
      const quantity: number = item.quantity || 0;
      total += quantity;
    });
    return total;
  }
  public selectItem(list: object[]) {
    this.selectList = list;
  }
  public timeChange(data: objAny): void {
    this.formInline.startTime = data[0];
    this.formInline.endTime = data[1];
    // this.getTableList();
  }
  public queryClick(): void {
    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }
  public pageChange(val: number): void {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public sizeChange(val: number): void {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }

  public sortChange(column: objAny): void {
    if (column.order === "normal") {
      this.formInline.globalOrder = "";
    } else {
      this.formInline.globalOrder =
        "name=" + column.key + ",age=" + column.order;
    }
    this.getTableList();
  }
  async getTableList(): Promise<void> {
    this.loading = true;
    const ret = await getProductionPage(this.formInline);

    if (ret.status === this.$config.apiStatus) {
      this.total = ret.total;
      this.tableList = ret.data;
    }
    this.loading = false;
    this.selectList = [];
  }
  // 设备入库
  public warehousingClick(item: objAny) {
    this.$Modal.confirm({
      title: i18n.t("tips") + "",
      content: i18n.t("productionOrder.warehousingConfirm") + "",
      onOk: async () => {
        const ret = await updStorageProduction({
          projectNamePkId: item.projectNamePkId
        });
        if (ret.status === this.$config.apiStatus) {
          this.$Message.success(i18n.t("operationSucess"));
          this.getTableList();
        }
      },
      onCancel: () => {
        this.$Message.info("Clicked cancel");
      }
    });
  }
  // 品质
  public qualityCheckClick(item: objAny) {
    const qualityCheck: objAny = this.$refs.qualityCheck;
    qualityCheck.open(item);
  }
  // 调整优先级
  public adjustPrioritiesClick(item: objAny) {
    const adjustPriorities: objAny = this.$refs.adjustPriorities;
    adjustPriorities.open(item);
  }
  // 设备发货
  public devDeliverGoodsClick(item: objAny) {
    const devDeliverGoods: objAny = this.$refs.devDeliverGoods;
    devDeliverGoods.open(item);
  }

  public addClick() {
    const addProduction: objAny = this.$refs.addProduction;
    addProduction.open({}, "add");
  }

  public updataClick(item: objAny) {
    const addProduction: objAny = this.$refs.addProduction;
    addProduction.open(item, "updata");
  }
  public detailsClick(item: objAny) {
    const addProduction: objAny = this.$refs.addProduction;
    addProduction.open(item, "details");
  }
  // 删除
  public delClick(item: objAny) {
    this.$Modal.confirm({
      title: i18n.t("tips") + "",
      content: i18n.t("productionOrder.delConfirm") + "",
      onOk: async () => {
        const ret = await delProduction({
          projectNamePkId: [item.projectNamePkId]
        });
        if (ret.status === this.$config.apiStatus) {
          this.$Message.success(i18n.t("operationSucess"));
          this.getTableList();
        }
      }
    });
  }
  //作废
  public invalidClick(item: objAny) {
    this.$Modal.confirm({
      title: i18n.t("tips") + "",
      content: i18n.t("productionOrder.voidConfirm") + "",
      onOk: async () => {
        const ret = await invalidProduction({
          projectNamePkId: item.projectNamePkId
        });
        if (ret.status === this.$config.apiStatus) {
          this.$Message.success(i18n.t("operationSucess"));
          this.getTableList();
        }
      }
    });
  }
  // 开始生产
  public updStartProduction(item: objAny) {
    this.$Modal.confirm({
      title: i18n.t("tips") + "",
      content: i18n.t("productionOrder.startConfirm") + "",
      onOk: async () => {
        const ret = await updStartProductionProduction({
          projectNamePkId: item.projectNamePkId
        });
        if (ret.status === this.$config.apiStatus) {
          this.$Message.success(i18n.t("operationSucess"));
          this.getTableList();
        }
      }
    });
  }

  async getOptionList() {
    const data = await getOptionList([optionKey.productionStatus]);
    this.productionStatusList = data[optionKey.productionStatus];
  }
  mounted() {
    const d: any = new Date();
    const end: number = Date.parse(d) / 1000;
    const start: number = end - 60 * 60 * 25 * 90;
    this.formInline.startTime = this.$common.userDate(
      start * 1000,
      "yyyy-MM-dd"
    );
    this.formInline.endTime = this.$common.userDate(end * 1000, "yyyy-MM-dd");
    this.time = [this.formInline.startTime, this.formInline.endTime];
    this.getTableList();
    this.getOptionList();
  }
}
